{
  "marketing": {
    "footerProduct": "產品",
    "navForDevelopers": "開發者",
    "navForPm": "產品經理",
    "navHome": "首頁",
    "navOpenApp": "開啟應用 →",
    "navStart": "免費開始 →",
    "navPricing": "定價"
  },
  "homepage": {
    "edition": "第 1 卷 · 2026 年版",
    "footerBlurb": "一個 agent 原生的想法孵化器。建構於自架的 Rust agent、Postgres + pgvector 以及 S3 支援的參照之上。閉源 SaaS——你的資料隨時可匯出為 markdown。",
    "footerSignIn": "登入",
    "footerGitHub": "GITHUB",
    "footerGoogle": "GOOGLE",
    "footerMagicLink": "魔術連結",
    "footerEdition": "第 1 卷 · 第 1 期 · 全球搶先體驗 · 2026 年版",
    "footerPrivacy": "隱私政策",
    "footerTerms": "服務條款",
    "footerContact": "聯絡我們"
  }
}
